/**
 * Montants rapides de la page cagnotte (/c/<slug>) — carte de don
 * (ordinateur) et panneau de don (téléphone).
 *
 * TOUJOURS 20 / 50 / 100 / 200 €, sur une seule ligne, quels que soient les
 * montants réglés par l'association sur sa page de paiement (Karim
 * 2026-10-13). Ces derniers servent encore à choisir le montant présélectionné
 * — s'il fait partie des quatre — et restent ceux de la page de paiement
 * elle-même (/c/<slug>/payment). Tout autre montant se tape à la main.
 */
export const MONTANTS_RAPIDES_CAGNOTTE: readonly number[] = [20, 50, 100, 200];

/**
 * Montant présélectionné : celui que l'association a mis par défaut, s'il est
 * l'un des quatre ; sinon le premier (20 €).
 */
export function montantRapideParDefaut(montantsAsso: readonly number[], indexDefaut: number): number {
  const choixAsso = montantsAsso[Math.min(Math.max(0, indexDefaut), montantsAsso.length - 1)];
  return choixAsso !== undefined && MONTANTS_RAPIDES_CAGNOTTE.includes(choixAsso)
    ? choixAsso
    : MONTANTS_RAPIDES_CAGNOTTE[0]!;
}
